module.exports = __webpack_public_path__ + "static/media/raduno1995.b0f2e2b9.jpg";